export const isInteger = (val) => /^[0-9]+$/.test(val);
